'use strict';

/**
 * Directive to display account-assignment autocomplete selection inputs.
 * Which account-assignment to display is determined via type.
 */
module.exports = (app) => app.directive('taskCounter', /* @ngInject */ function () {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: `./${BUILD_PATH}/task-counter.directive.html`,
        controller: /* @ngInject */ function ($scope, taskService, sseService) {

            init();

            $scope.count = 0;
            const iframeRoute = 'client/task/list';
            $scope.goToTasklist = goToTasklist;

            let countChangeListener;

            function goToTasklist() {
                window.setIFrameRoute(iframeRoute);
                window.openContent('container.htm&if=' + iframeRoute);
            }

            function init() {
                fetchCount();
            }

            /**
             * Get task count number
             */
            function fetchCount() {
                taskService.getTaskCount().then((count) => {
                    updateCount(count.count)
                    listenToTaskCountChanges()
                }, (error) => {
                    console.error(error);
                })
            }

            /**
             * Listen to task count changes via server send events (sse)
             */
            function listenToTaskCountChanges() {
                countChangeListener = (event) => {
                    if (event && event.detail && typeof event.detail.count === 'number') {
                        updateCount(event.detail.count)
                    }
                };
                window.addEventListener(sseService.IDS.TASK_COUNT, countChangeListener)
            }

            /**
             *
             * @param count {number} - the new count
             */
            function updateCount(count) {
                $scope.count = count;
                taskService.setOpenTaskCount(count);
                $scope.$apply();
            }

            /**
             * close sse connection when the directive is about to be destroyed
             */
            $scope.$on('$destroy', function () {
                sseService.closeConnection(sseService.IDS.TASK_COUNT);
                window.removeEventListener(sseService.IDS.TASK_COUNT, countChangeListener)
            });

        }

    }
});
